/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_EditInputs */

const vi_weighing_edit = /** @type {(inputs: Weighing_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu cân`)
};

/**

* @param {Weighing_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_edit = /** @type {((inputs?: Weighing_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_edit(inputs)
});